// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import "./accounts/registrations_controller"
//application.register("accounts--registrations", Accounts__RegistrationsController)

import "./buttons_controller"
//application.register("buttons", ButtonsController)

import "./categories_controller"
//application.register("categories", CategoriesController)

import "./competitors_controller"
//application.register("competitors", CompetitorsController)

import "./captions_controller"

import "./dashboard_controller"
//application.register("dashboard", DashboardController)

import "./hashtags_controller"
//application.register("hashtags", HashtagsController)

import "./strategy_profiles_controller"

import LinkToAddFieldsController from "./link_to_add_fields_controller"
application.register("link-to-add-fields", LinkToAddFieldsController)

import RedirectController from "./redirect_controller"
application.register("redirect", RedirectController)

import Sjabloon__AccordionController from "./sjabloon/accordion_controller"
application.register("sjabloon--accordion", Sjabloon__AccordionController)

import Sjabloon__AnnouncementsController from "./sjabloon/announcements_controller"
application.register("sjabloon--announcements", Sjabloon__AnnouncementsController)

import Sjabloon__CouponController from "./sjabloon/coupon_controller"
application.register("sjabloon--coupon", Sjabloon__CouponController)

import Sjabloon__DropdownController from "./sjabloon/dropdown_controller"
application.register("sjabloon--dropdown", Sjabloon__DropdownController)

import Sjabloon__DropzoneController from "./sjabloon/dropzone_controller"
application.register("sjabloon--dropzone", Sjabloon__DropzoneController)

import Sjabloon__FillFormController from "./sjabloon/fill_form_controller"
application.register("sjabloon--fill-form", Sjabloon__FillFormController)

import Sjabloon__FlashController from "./sjabloon/flash_controller"
application.register("sjabloon--flash", Sjabloon__FlashController)

import Sjabloon__FormController from "./sjabloon/form_controller"
application.register("sjabloon--form", Sjabloon__FormController)

import Sjabloon__FormValidationController from "./sjabloon/form_validation_controller"
application.register("sjabloon--form-validation", Sjabloon__FormValidationController)

import Sjabloon__ModalController from "./sjabloon/modal_controller"
application.register("sjabloon--modal", Sjabloon__ModalController)

import Sjabloon__NavigationController from "./sjabloon/navigation_controller"
application.register("sjabloon--navigation", Sjabloon__NavigationController)

import Sjabloon__PlanSwitchController from "./sjabloon/plan_switch_controller"
application.register("sjabloon--plan-switch", Sjabloon__PlanSwitchController)

import "./sjabloon/pricing_controller"
//application.register("sjabloon--pricing", Sjabloon__PricingController)

import Sjabloon__SiteAnnouncementsController from "./sjabloon/site_announcements_controller"
application.register("sjabloon--site-announcements", Sjabloon__SiteAnnouncementsController)

import Sjabloon__StripeController from "./sjabloon/stripe_controller"
application.register("sjabloon--stripe", Sjabloon__StripeController)

import Sjabloon__TabsController from "./sjabloon/tabs_controller"
application.register("sjabloon--tabs", Sjabloon__TabsController)

import Sjabloon__ToggleController from "./sjabloon/toggle_controller"
application.register("sjabloon--toggle", Sjabloon__ToggleController)
